import { render, staticRenderFns } from "./Liity.vue?vue&type=template&id=908792b2&scoped=true"
var script = {}
import style0 from "./Liity.vue?vue&type=style&index=0&id=908792b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "908792b2",
  null
  
)

export default component.exports